<template>
    <div>
        <div class="navbar-divider is-hidden-tablet" />
        <div class="navbar-item is-tab is-hidden-tablet">
            <LanguageSwitcher :as-icons="true" class="is-pulled-right" @click="toggleHamburger" />
            <span v-translate>Switch language:</span>
        </div>
        <a v-if="$auth.check()" v-translate
           class="navbar-item is-tab is-hidden-tablet" @click.prevent="logout()">Logout</a>
    </div>
</template>

<script>
    import LanguageSwitcher from 'common/LanguageSwitcher.vue'
    import { mapMutations } from 'vuex'
    import * as Cookie from 'tiny-cookie'

    export default {
        components: { LanguageSwitcher },

        methods: {
            ...mapMutations([ 'toggleHamburger' ]),
            logout() {
                this.$auth.logout()
                this.$router.go('/')
                Cookie.remove('only_horses_mode')

            }
        }
    }
</script>
